<template>
  <!-- <el-select
      v-model="groupId"
      placeholder="请选择行业管理"
      clearable
      @change="handleChange"
    >
      <el-option
        v-for="item in list"
        :key="item.groupId"
        :label="item.groupName"
        :value="item.groupId"
      >
      </el-option>
    </el-select> -->
  <div>
    <el-cascader
      v-model="selectedOptions"
      style="width:100%"
      :options="list"
      :props="props"
      @change="handleChange"
    ></el-cascader>
    <!-- <el-select
      v-else
      v-model="selectedOptions"
      style="width:100%"
      placeholder="请选择二级类目">
      <el-option
        v-for="item in list"
        :key="item.serviceCategoryId"
        :label="item.serviceCategoryName"
        :value="item.serviceCategoryId"
      >
      </el-option>
    </el-select> -->
  </div>
</template>

<script>
export default {
  name: 'CategoryServiceSelectNew',
  components: {},
  props: {
    value: {
      required: true
    },
    callback: {
      type: Function
    },
    option: {
      type: Object,
      default() {
        return {
          serviceId: null,
          classId: []
        }
      }
    }
  },
  data() {
    return {
      props: {
        label: 'serviceCategoryName',
        value: 'serviceCategoryId'
        // children: 'servicePackages'
      },
      list: [],
      inited: false
    }
  },
  computed: {
    selectedOptions: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    option: {
      handler: function(val) {
        if (val.serviceId && val.classId && val.classId.length === 2) {
          if (this.inited) {
            this.selectedOptions = []
          }
          this.fetchList()
        }
      },
      immediate: true
    }
  },
  mounted() {
    // this.fetchList()
    this.inited = true
  },
  methods: {
    handleChange(val) {
      console.log(arguments)
      const [l1, l2] = val
      const item = this.list.find(i => i.serviceCategoryId === l1) || {}
      console.log(item)
      const sItem = (item.children || []).find(i => i.serviceCategoryId === l2) || {}
      console.log(sItem)
      this.callback && this.callback(sItem)
    },
    fetchList() {
      const [classIdLevel1, classIdLevel2] = this.option.classId
      this.$store.dispatch('account/getservicecategorys', {
        payload: {
          serviceId: this.option.serviceId,
          classIdLevel1,
          classIdLevel2
        },
        success: (res) => {
          this.list = res.data.records.map(i => {
            i.children = (i.servicePackages || []).map(s => ({
              ...s,
              pServiceCategoryId: s.serviceCategoryId,
              serviceCategoryId: s.servicePackageId,
              serviceCategoryName: s.servicePackageName
            }))
            return i
          })
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
